var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{style:({
    stroke: _vm.serie.colorPrimary,
    strokeWidth: _vm.serie.strokeWidth,
    fill: 'none'
  }),attrs:{"d":_vm.path}})}
var staticRenderFns = []

export { render, staticRenderFns }